import { useState } from 'react';
import Layout from '@/components/Layout';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { signIn } from 'next-auth/react';
import { getSession } from 'next-auth/react';

const fetchUrl = process.env.NEXT_PUBLIC_BASE_ENDPOINT + 'auth';

export default function SignIn() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setError] = useState('');

    let router = useRouter();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const ret = await signIn('credentials', {
                email,
                password,
                redirect: false,
            });

            const { error } = ret;

            if (error) {
                setError(error);
            } else {
                setError('');
                router.push('/browse');
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div className="signin form-pages">
                <form className="signin-form form" onSubmit={handleLogin}>
                    <h2>Ingresá en LPF Play</h2>
                    <label>Email </label>
                    <input
                        type="email"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <label>Contraseña: </label>
                    <input
                        type="password"
                        placeholder="Contraseña"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    ></input>
                    {loginError && <p className="error">{loginError}</p>}
                    <button>Ingresá</button>
                    {/* {!posting && <button>Ingresar</button>}
          {posting && <button disabled>Posting to your blog!</button>} */}
                    <div className="forgot-password">
                        <Link href="forgot-password">
                            <a>Olvidé mi contraseña</a>
                        </Link>
                    </div>
                    <div className="no-account">
                        ¿No tenés una cuenta?{' '}
                        <Link href="/signup">
                            <a className="registerLink">Registrate acá</a>
                        </Link>
                        .
                    </div>
                </form>
            </div>
        </>
    );
}

SignIn.getLayout = function getLayout(page) {
    return (
        <Layout title="Ingresá en LPF Play" className="signin form-pages">
            {page}
        </Layout>
    );
};

export async function getServerSideProps(ctx) {
    const session = await getSession(ctx);

    if (session) {
        return {
            redirect: {
                permanent: false,
                destination: '/browse',
            },
            props: {},
        };
    }

    // Pass data to the page via props
    return { props: { session: session } };
}
